import { render, staticRenderFns } from "./NewProjectPage.vue?vue&type=template&id=4187f4a6&scoped=true"
import script from "./NewProjectPage.vue?vue&type=script&lang=js"
export * from "./NewProjectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187f4a6",
  null
  
)

export default component.exports